import {DetailColumns, DetailPane, FormDialog} from '@management-ui/core';
import {Edit} from '@mui/icons-material';
import React, {useContext, useState} from 'react';
import ConfirmDate from '../../../../components/ConfirmDate';
import {ServiceContext} from '../../../../components/Services';
import Text from '../../../../components/Text';
import SalesOrderForm from '../../forms/SalesOrderForm';

const Loading = ({order, onOrderUpdated}) => {
  const services = useContext(ServiceContext);
  const [fields, setFields] = useState('core');
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <DetailColumns columns={[

        <DetailPane
          title="Loading Details"
          actions={order.archived || order.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('loading') || setShowForm(true)},
          ]}
          details={[
            {
              title: 'Expected Loading Date',
              value: (
                <ConfirmDate
                  order={order}
                  field="loading_date"
                  service={services.salesOrder.saveOrder}
                  onUpdated={onOrderUpdated}
                />
              )
            },
          ]}
        />,

        <DetailPane
          title="Payment Terms"
          actions={order.archived ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('payment') || setShowForm(true)},
          ]}
          details={[
            {title: 'Terms', value: <Text text={order.payment_terms ?? '-'}/>}
          ]}
        />,
      ]}/>

      <FormDialog
        title="Edit Sales Order"
        open={showForm}
        onClose={() => setShowForm(false)}
        render={(props) => (
          <SalesOrderForm
            {...props}
            order={order}
            fields={fields}
            onSaved={(updated) => setShowForm(false) || onOrderUpdated(updated)}/>
        )}
      />

    </>
  );
}

export default Loading;
